import { logger } from '@trigger.dev/sdk'
import DolfinLogger from '.'

class TriggerLogger extends DolfinLogger {
  public static log(message: any) {
    logger.log(message)
  }

  public static error(message: any) {
    logger.error(message)
  }

  public static warn(message: any) {
    logger.warn(message)
  }

  public static info(message: any) {
    logger.info(message)
  }
}

export { TriggerLogger }
